/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * Normalizes an array of questions by sorting and reindexing their steps and positions
 * @param {Array<{step: number, position: number}>} questions Array of questions with step and position properties
 * @returns {Array<{step: number, position: number}>} New array with normalized questions
 */
export function normalizeQuestions (questions) {
    // Create a copy only if the array is frozen
    // Do operations in place too if the array is not frozen
    const normalizedQuestions = Object.isFrozen(questions) 
        ? questions.map((q) => ({ ...q }))
        : questions;

    // Sort by step and position
    normalizedQuestions.sort((a, b) => {
        if (a.step !== b.step) {
            return a.step - b.step;
        }
        return a.position - b.position;
    });

    // Group questions by step
    const stepGroups = normalizedQuestions.reduce((acc, q) => {
        acc[q.step] = acc[q.step] || [];
        acc[q.step].push(q);
        return acc;
    }, {});

    // Normalize steps and positions
    let newStep = 1;
    Object.keys(stepGroups)
        .sort((a, b) => Number(a) - Number(b))
        .forEach((step) => {
            stepGroups[step].forEach((question, idx) => {
                question.step = newStep;
                question.position = idx + 1;
            });
            newStep++;
        });

    return normalizedQuestions;
}
